export default {
    UP: 'up',
    DOWN: 'down',
    RIGHT: 'right',
    LEFT: 'left',
    PLAY: 'play',
    STOP: 'stop',
    PAUSE: 'pause',
};
